import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import LeaveRequestForm from "./LeaveRequestForm";
import LeaveRequestList from "./LeaveRequestList";

const LeaveRequest = () => {
  const { hrmsUser, userType } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedEmployee, setSelectedEmployee] = useState(
    location.state?.employee || null
  );

  const [showForm, setShowForm] = useState(
    Boolean(location.state?.employee)
  );

  const [refreshTrigger, setRefreshTrigger] = useState(0);

  React.useEffect(() => {
    if (userType !== 'hrms' && userType !== 'admin') {
      navigate('/hrms/login');
    }
  }, [userType, navigate]);


  if (userType === 'hrms' && !hrmsUser) {
    return <div>Loading...</div>;
  }

  if (userType !== 'hrms' && userType !== 'admin') {
    navigate('/hrms/login');
    return null;
  }

  const handleFormSuccess = () => {
    setShowForm(false);
    setSelectedEmployee(null);
    setRefreshTrigger((p) => p + 1);
  };

  return (
    <div className="container-fluid leave-management-page leave-employee-page py-3">
      <div className="leave-page-header d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
        <div>
          <span className="leave-page-kicker">Leave Management</span>
          <h4 className="leave-page-title mb-1">Create Leave Request</h4>
          <p className="leave-page-description mb-0">
            Submit new leave applications and keep track of every request in one place.
          </p>
        </div>

        {userType === 'hrms' && (
          <button
            className="btn btn-primary leave-page-action"
            onClick={() => setShowForm(true)}
          >
            Apply New Leave
          </button>
        )}

      </div>

      {showForm && (
        <LeaveRequestForm
          isAdmin={userType === "admin"}
          selectedEmployee={selectedEmployee}
          onSuccess={handleFormSuccess}
          onCancel={() => {
            setShowForm(false);
            setSelectedEmployee(null);
          }}
        />
      )}

      {userType === "hrms" && (
        <LeaveRequestList refreshTrigger={refreshTrigger} />
      )}

    </div>
  );
};

export default LeaveRequest;
